import { VERIFIABLE_CODES } from '../../constants';
import type { DocumentView, FormulationReviewDocument, StatementOption } from '../../types';

// Label statements about the product itself first, then ones that at least name it.
export const rankStatement = (option: StatementOption): number =>
    Number(option.selfStatement) * 2 + Number(option.mentionsProduct);

export const toDocumentViews = (
    documents: FormulationReviewDocument[],
    canVerify: boolean
): DocumentView[] =>
    documents.map((document, documentIndex) => ({
        error: document.error ?? null,
        key: `${documentIndex}-${document.url}`,
        mixingOrderStatements: document.mixingOrderStatements ?? [],
        statements: (document.formulationStatements ?? [])
            .map((statement, statementIndex) => ({
                documentUrl: document.url,
                excerpt: statement.excerpt,
                isSelectable:
                    canVerify &&
                    statement.suggestedCode !== null &&
                    VERIFIABLE_CODES.has(statement.suggestedCode.toUpperCase()),
                key: `${documentIndex}-${statementIndex}`,
                mentionsProduct: statement.mentionsProduct,
                selfStatement: statement.selfStatement,
                suggestedCode: statement.suggestedCode
            }))
            .sort((first, second) => rankStatement(second) - rankStatement(first)),
        type: document.type,
        url: document.url
    }));
